(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodCopyToClipboardPanel', sodCopyToClipboardPanel);

    function sodCopyToClipboardPanel(lodash, $timeout) {
        return {
            restrict: 'E',
            transclude: true,
            link: function(scope, elem, attr) {
                scope.copyToClipboard = copyToClipboardFunc;

                if (lodash.has(attr, 'class')) {
                    scope.parentClass = attr.class;
                }

                function copyToClipboardFunc() {
                    try {
                        clipboard.copy({
                            // "text/plain": elem.find('ng-transclude').text(),
                            "text/html": elem.find('ng-transclude').html()
                        });
                        scope.copied = true;
                        $timeout(function() {
                            scope.copied = false;
                        }, 1500);
                    } catch (err) {
                        console.log(err);
                    }
                }
            },
            template: '<div class="copy-to-clipboard-panel <%parentClass%>">' +
                '<ng-transclude></ng-transclude>' +
                // '<sod-tooltip class="popover-top" content="\'Copied\'">' +
                '<button class="button default copy-to-clipboard-button" ng-click="copyToClipboard()"><i class="fa fa-clipboard"></i></button>' +
                '<div class="copied-text" ng-show="copied">Copied</div>' +
                // '</sod-tooltip>' +
                '</div>'
        };
    }
})();